import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_flexwrap-reverse _ai-c _gap-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_button = _resolveComponent("base-button")
  const _component_modal_box = _resolveComponent("modal-box")

  return (_openBlock(), _createBlock(_component_modal_box, {
    title: _ctx.Resources.Checkout.UtilizeBonusAmountModalTitle,
    icon: "piggy-bank",
    "is-processing": _ctx.isProcessing,
    "is-visible": $props.isVisible
  }, {
    actions: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("a", {
          href: "",
          class: "gfu-link gfu-link--accent _ttl _grow-1 _tac",
          onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.close && $options.close(...args)), ["prevent"])),
          "data-qa": "modal-link:KeepBonusAmount"
        }, _toDisplayString(_ctx.Resources.Checkout.UtilizeBonusAmountCancelButton), 1 /* TEXT */),
        _createVNode(_component_base_button, {
          class: "_grow-1",
          size: "default",
          width: "compact",
          "text-transform": "none",
          wide: true,
          bold: true,
          theme: "accent",
          icon: "file-excel",
          enabled: !_ctx.isProcessing,
          onClick: _withModifiers($options.submit, ["prevent"]),
          "data-qa": "modal-button:UseBonusAmount"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.Resources.Checkout.UtilizeBonusAmountSubmitButton), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["enabled", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(_ctx.Resources.Checkout.UtilizeBonusAmountModalDescription), 1 /* TEXT */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["title", "is-processing", "is-visible"]))
}